import { render, staticRenderFns } from "./StaffDetailPage.vue?vue&type=template&id=6f8e485e&scoped=true&"
import script from "./StaffDetailPage.vue?vue&type=script&lang=ts&setup=true&"
export * from "./StaffDetailPage.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8e485e",
  null
  
)

export default component.exports